import { Injectable } from '@angular/core';
import { ItemListDTO, MobileInventoryCountService } from '@ups/tool-tracker';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchItemsService {
  constructor(public inventoryCountService: MobileInventoryCountService) {}

  search(searchString: string) {
    const filtered = this.inventoryCountService.itemList.filter(
      (item: ItemListDTO) => {
        return (
          item.itemName?.toLowerCase().indexOf(searchString.toLowerCase()) > -1
        );
      }
    );

    return of(filtered);
  }
}
